/* ==========================================================================
   Le Petit Quché — "Добави картичка" add-on.
   Подход: при клик блокираме еднократно, добавяме САМО картичката, и после
   програмно повтаряме клика с bypass флаг — така нативният флоу на темата
   се изпълнява напълно нормално (добавя основния продукт + отваря drawer-а),
   без да имитираме вътрешния му API.
   ========================================================================== */

var lpqBypass = false;

document.addEventListener('click', function (e) {
  // Вторият, програмен клик минава без намеса.
  if (lpqBypass) {
    lpqBypass = false;
    return;
  }

  var btn = e.target.closest('.product-buy-buttons--primary');
  if (!btn) return;

  var form = btn.closest('form');
  if (!form) return;

  var checkbox = form.querySelector('[data-lpq-card-addon]');
  if (!checkbox || !checkbox.checked) return;

  var cardVariantId = checkbox.dataset.addonVariantId;
  if (!cardVariantId) return;

  // Спираме първия клик, за да добавим картичката първо.
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(cardVariantId, 10), quantity: 1 })
  })
    .then(function (r) {
      if (!r.ok) throw new Error('Card add failed: ' + r.status);
      return r.json();
    })
    .then(function () {
      // Пускаме нативния флоу — той добавя основния продукт и отваря drawer-а.
      lpqBypass = true;
      btn.click();
    })
    .catch(function (err) {
      console.error('LPQ card addon error:', err);
      lpqBypass = true;
      btn.click(); // дори при грешка, основният продукт да влезе нормално
    });
}, true);